import React, { useEffect, useState } from "react";
import useStyles from "../common/Styles";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import tribesMap from "../../../../assets/Water_User_Tribes.json";
import { useSelector } from "react-redux";
import { usePrevious } from "components/common/usePrevious";
import { Box } from "@material-ui/core";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

var map;
var allModelLayer;

function TribesMap() {
  const classes = useStyles();
  const { toggle_about, tribe_selected } = useSelector(
    (state) => state.water_user
  );
  const [selectedFeature, setSelectedFeature] = useState(null);
  const previousFeature = usePrevious(selectedFeature);
  const { isMobile } = useGetViewPortDimensions();

  const onEachFeature = (feature, layer) => {
    layer
      .setStyle({
        fillColor: "#699EE0",
        fillOpacity: 0.5,
        weight: 1,
        color: "#707070",
      })
      .bindTooltip(feature.properties["Tribal.csv.name"], { direction: "top" })
      .openTooltip();

    if (feature.properties["Tribal.csv.name"] === tribe_selected.name) {
      highlightFeature(layer);
      setSelectedFeature(layer);
    }
  };
  const highlightFeature = (layer) => {
    // let layer = e.target;
    layer.setStyle({
      weight: 3,
      color: "#3559C8",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }

    if (
      layer.feature.properties.MAIL_NAME === "Yavapai-Apache Tribe" ||
      layer.feature.properties.MAIL_NAME === "Tonto Apache Tribe"
    ) {
      map.setView(
        new L.LatLngBounds(
          new L.LatLng(
            layer._bounds._northEast.lat,
            layer._bounds._northEast.lng
          ),
          new L.LatLng(
            layer._bounds._southWest.lat,
            layer._bounds._northEast.lng
          )
        ).getCenter(),
        10
      );
    } else {
      map.setView(
        new L.LatLngBounds(
          new L.LatLng(
            layer._bounds._northEast.lat,
            layer._bounds._northEast.lng
          ),
          new L.LatLng(
            layer._bounds._southWest.lat,
            layer._bounds._northEast.lng
          )
        ).getCenter(),
        7.5
      );
    }
  };

  const toggleMaps = () => {
    if (map) {
      map.remove();
    }
    map = L.map("map", {
      center: new L.LatLngBounds(
        new L.LatLng(31.9, -113),
        new L.LatLng(38, -111.2)
      ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      zoom: 7,
      maxZoom: 15,
      // maxZoom: 11,
      minZoom: 6,

      // maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // add zoom control
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);

    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(tribesMap, {
      onEachFeature,
    }).addTo(map);
  }

  useEffect(toggleMaps, [toggle_about]);

  const selectHook = () => {
    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(tribesMap, {
      onEachFeature,
    }).addTo(map);
  }

  useEffect(selectHook, [tribe_selected]);


  const prevFeatureHook = () => {
    if (previousFeature) {
      previousFeature.setStyle({
        fillColor: "#699EE0",
        fillOpacity: 0.5,
        weight: 1,
        color: "#707070",
      });
    }
  }

  useEffect(prevFeatureHook, [selectedFeature]);

  return (
    <Box className={isMobile ? classes.mapAreaResponsive : classes.mapArea}>
      <div className={isMobile ? classes.mapResponsive : classes.map} id="map"></div>
    </Box>
  );
}

export default TribesMap;
